import type {
  HeroAndTextView,
  SectionItemDM,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { layoutHeroAndText } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/heroAndText/helpers/HeroAndTextLayout';

export async function addHeroAndText(
  viewData: ViewData,
  section: SectionItemDM
): Promise<ViewData> {
  const heroAndTextView = getHeroAndTextView(viewData, section);

  await layoutHeroAndText({
    section: heroAndTextView,
    viewData,
  });

  return viewData;
}

function getHeroAndTextView(
  viewData: ViewData,
  section: SectionItemDM
): HeroAndTextView {
  return {
    id: section.id,
    key: [
      'brandconcession',
      viewData.modelData.concessionId,
      'section',
      section.id,
    ].join('-'),
    type: section.template,
    dtoData: section,
    sectionId: section.id,
  };
}
